import * as React from 'react';
import { cva, VariantProps } from 'class-variance-authority';

import { cn } from '../../utils/cn';

const dialogHeaderVariants = cva('rocco-dialog-header', {
    variants: {
        variant: {
            default: 'flex flex-col space-y-1.5 text-center sm:text-left',
        },
    },
    defaultVariants: {
        variant: 'default',
    },
});

export const DialogHeader = ({
    className,
    variant,
    ...props
}: React.HTMLAttributes<HTMLDivElement> &
    VariantProps<typeof dialogHeaderVariants>) => (
    <div
        className={cn(dialogHeaderVariants({ variant, className }))}
        {...props}
    />
);

DialogHeader.displayName = 'DialogHeader';
